import {
  Component,
  OnInit,
  Inject,
  Optional,
} from "@angular/core";
import { incidenciaDetalleQABean } from "src/app/shared/model/incidencias/incidenciaDetalleQABean.model";
import { Incidencias } from "src/app/shared/model/incidencias/incidencia.model";
import { Proyectos } from "src/app/shared/model/incidencias/proyectos.model";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { EvidenciaBean } from "src/app/shared/model/incidencias/evidenciaBean.model";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { DetIncBotones } from "src/app/shared/model/incidencias/detIncBotones.model";
import {
  ComentariosDesarrolloComponent,
  ResolucionSinSelector,
} from "./comentariosDesarrollo/comentariosDesarrollo.component";
import swal from "sweetalert2";
import { MensajesFijosEnum } from "src/app/utilerias/enums/mensajes-fijos-enum";
import { EmpleadoService } from "src/app/empleado/empleado.service";
import { Area } from "src/app/shared/model/empleado/area.model";
import { Puesto } from "src/app/shared/model/empleado/puesto.model";
import { Empleado } from "src/app/shared/model/empleado/empleado.model";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { NgIf, NgFor } from "@angular/common";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ReasignarResponsableComponent } from "../detallesincidencia/reasignar-responsable/reasignar-responsable.component";
import { ResolucionEstructurada } from "./resolucion-causa-origen.util";
import {
  ContextoDetalle,
  DetalleIncidenciaBase,
} from "../detalles-comun/detalle-incidencia-base";
import {
  buscaVersion,
  equipoConPuesto,
  versionesDeEtapa,
} from "../etapa-incidencia.util";
import {
  proximaVersionQA,
  rechazoDelGuardado,
  ResolucionEstado,
  resuelveSinSelector,
  textoVersionVigente,
  versionParaMovimiento,
} from "../resolucion-version.util";

@Component({
  selector: "app-detallesIncidenciaDesarrollo",
  standalone: true,
  templateUrl: "./detallesIncidenciaDesarrollo.component.html",
  styleUrls: [
    "./detallesIncidenciaDesarrollo.component.css",
    "../detalles-comun/resolucion-version.css",
  ],
  imports: [
    MatIconButton,
    MatIcon,
    NgIf,
    NgFor,
    MatButton,
    ReactiveFormsModule,
  ],
})
export class DetallesIncidenciaDesarrolloComponent extends DetalleIncidenciaBase implements OnInit {
  detalleIncidencia = new incidenciaDetalleQABean();
  detalleProyecto = new Proyectos();
  cidencia: Incidencias;
  beanproyectos = new Proyectos();
  listaproyectos: Array<Proyectos>;
  listaEvidencias: EvidenciaBean[];

  image: any;
  img: any;

  nombreImagenEvidenica: string;
  version: any;
  statusColor: string = "#f25c05";
  /** El chip de estatus no lleva color propio: toma el de la página. */
  readonly colorEstatusChip = null;
  estatusLiderDev: Boolean = false;
  estatusDev: Boolean = false;
  listaEmpleadosQA: Empleado[] = [];
  selectedEmpleado: number;
  motivo: string = "";
  listaVss: any;
  protected readonly muestraCausaOrigen = true;
  protected readonly comentarioConDesarrollador = true;

  constructor(
    private readonly empleadoService: EmpleadoService,
    private readonly sanitizer: DomSanitizer,
    @Optional() @Inject(MAT_DIALOG_DATA) private parameter: any,
    @Optional() public dialogRef: MatDialogRef<DetallesIncidenciaDesarrolloComponent>,
    private readonly router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.step = 0;
    this.cargaNombreUsuarioLogeado();
    this.formComentario = new FormGroup({
      descripcion: new FormControl("", [Validators.required]),
    });

    const routeState = history.state;
    const context: ContextoDetalle | null =
      this.parameter ??
      (routeState?.incidencia ? routeState : null);

    if (context) {
      this.inicializa(context);
      return;
    }

    // Enlace directo: sin el estado del tablero se consulta por el :id de la ruta.
    void this.cargaPorEnlace(
      (contexto) => this.inicializa(contexto),
      () => this.regresar()
    );
  }

  private inicializa(context: ContextoDetalle) {
    this.parameter = context;
    this.detallemodal = context.incidencia;
    this.asignaProyecto(context.proyecto);
    this.statusColor = this.obtenerColorEstatus(this.detallemodal.estatus);
    this.detallemodal.colorEstatus = this.statusColor;
    this.nombreProyecto = context.proyecto?.nombre || "Sin proyecto asignado";
    this.selectedEmpleado = this.detallemodal.id_usuario_desarrollo || null;
    this.listaVss = versionesDeEtapa(this.proyecto, this.detallemodal.id_etapa);
    this.actualizaVersiones();
    this.consultaAreaPuestoEmpleado();
    this.consultaNombreEmpleado(this.detallemodal);
    this.consultaNombreAsignado(this.detallemodal);
    this.muestraBotones(this.detallemodal.estatus);
    this.getDetalleIncidencia();
    this.refreshView();
  }

  consultaAreaPuestoEmpleado() {
    this.empleadoService.consultaAreaPuestoEmpleado().subscribe((emp) => {
      if (emp?.area) {
        this.validaArea(emp.area, emp.puesto);
      }
      this.refreshView();
    });
  }

  validaArea(area: Area, puesto: Puesto) {
    switch (area.area) {
      case "Desarrollo":
        if (puesto?.puesto === "Lider") {
          this.estatusLiderDev = true;
          // Los desarrolladores de la etapa, del proyecto (ver etapa-incidencia.util).
          this.listaEmpleados = equipoConPuesto(
            this.proyecto,
            this.detallemodal.id_etapa,
            "Desarrollador"
          );
          if (this.detallemodal.id_usuario_desarrollo === 0)
            this.nombreCompletoAsignado = "N/A";
          this.refreshView();
        } else if (puesto?.puesto === "Desarrollador") {
          this.estatusDev = true;
          this.refreshView();
        }
        break;
      case "Pruebas":
        this.refreshView();
        break;
    }
  }

  onCloseClick() {
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }

    this.regresar();
  }

  muestraBotones(estatus: String) {
    this.botones.length = 0;
    switch (estatus) {
      case Constantes.ABIERTO: {
        this.botones.push(new DetIncBotones("Agregar comentario", "message"));
        this.botones.push(new DetIncBotones("Proceso", "find_in_page"));
        break;
      }
      case Constantes.PROCESO: {
        this.botones.push(new DetIncBotones("Resuelto", "done_all"));
        break;
      }
      case Constantes.OBSERVACIONES: {
        this.botones.push(new DetIncBotones("Agregar comentario", "message"));
        this.botones.push(new DetIncBotones("Proceso", "find_in_page"));
        break;
      }
      case Constantes.RESUELTO:
      case Constantes.REVISION: {
        this.botones.push(new DetIncBotones("Agregar comentario", "message"));
        break;
      }
      case Constantes.VOBO:
      case Constantes.CANCELADO:
      default: {
        break;
      }
    }
  }

  getDetalleIncidencia() {
    // T3b: con cada lectura del historial, también el estado de la resolución.
    this.consultaEstadoResolucion();
    this.incidenciasService
      .detalleIncidencia(this.detallemodal)
      .subscribe((res) => {
        this.separaDetalles(res);
        // Las versiones de la etapa se cargan siempre: antes, ya resuelta, no
        // había lista y la ficha pintaba el id de la versión.
        this.listaVss = versionesDeEtapa(this.proyecto, this.detallemodal.id_etapa);

        if (this.listadetalles.length > 0) {
          this.detalleIncidencia = this.listadetalles[0];
          this.version = this.versionDelMovimiento();
        } else {
          this.version = null;
        }

        this.actualizaVersiones();
        this.actualizaEvidenciasGenerales();

        this.totalHistorial = this.listaHistorial.length;
        if (this.number(this.detallemodal.esComentario)) {
          this.eliminaNotificacion(this.detallemodal.idNotificacionUsuario);
        }

        this.refreshView();
      });
  }

  /**
   * Versión con la que viajan los movimientos (como siempre): en RESUELTO la
   * de la resolución y, si no, la del último movimiento. No es la que se pinta
   * como "Versión afectada" ni contra la que se valida al resolver: esa es la
   * reportada (ver obtenerIdVersionReportada). El centinela de T3b nunca
   * viaja: en su lugar va la detectada y el servidor pone la versión viva.
   */
  private versionDelMovimiento(): any {
    const idVersion = versionParaMovimiento(
      this.detallemodal.estatus === Constantes.RESUELTO
        ? this.detalleIncidencia.id_version_resuelto
        : this.detalleIncidencia.id_version_incidencia,
      this.detallemodal.version
    );
    return (
      buscaVersion(this.proyecto, this.detallemodal.id_etapa, idVersion) ??
      idVersion ??
      null
    );
  }

  regresar() {
    this.router.navigate(["/INCIDENCIAS/INC_DESARROLLO"]);
  }

  stringify(value: any): string {
    return String(value);
  }

  getActionLabel(titulo: string): string {
    switch (titulo) {
      case "Agregar comentario":
        return "Comentar";
      case "Proceso":
        return "Enviar a proceso";
      case "Resuelto":
        return "Marcar resuelto";
      case "Observacion":
        return "Marcar observación";
      case "Cancelar":
        return "Cerrar ticket";
      default:
        return titulo;
    }
  }

  getActionTone(titulo: string): string {
    switch (titulo) {
      case "Proceso":
      case "Resuelto":
        return "primary";
      default:
        return "neutral";
    }
  }

  hasAssignmentTools(): boolean {
    return this.estatusLiderDev === true;
  }

  abrirReasignacion() {
    const dialogRef = this.dialog.open(ReasignarResponsableComponent, {
      width: "auto",
      maxWidth: "96vw",
      maxHeight: "92vh",
      panelClass: "custom-modalbox",
      data: {
        listaEmpleados: this.listaEmpleados,
        selectedEmpleado: this.selectedEmpleado,
        motivo: this.motivo,
        contextLabel: "Incidencias Desarrollo",
        roleLabel: "un desarrollador",
        assignLabel: "Reasignar a",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      this.guardaAsignado(result.selectedEmpleado, result.motivo);
    });
  }

  guardaAsignado(selectedEmpleado?: number, motivo?: string) {
    this.selectedEmpleado = Number(selectedEmpleado ?? this.selectedEmpleado ?? 0);
    this.motivo = String(motivo ?? this.motivo ?? "").trim();

    if (!this.selectedEmpleado || !this.motivo) {
      return;
    }

    const desarrollador = this.selectedEmpleado;
    const empleado = this.listaEmpleados?.find(
      (ab) => ab?.usuario?.id === desarrollador
    )?.persona?.nombreCompleto;

    if (!empleado) {
      return;
    }

    const estatusSiguiente =
      this.detallemodal.estatus === Constantes.ABIERTO
        ? Constantes.PROCESO
        : this.detallemodal.estatus;

    if (this.detallemodal.estatus === Constantes.ABIERTO) {
      this.detalleIncidencia.id_emp_reasignado = desarrollador;
    } else {
      this.detalleIncidencia.id_emp_asignado =
        this.detallemodal.id_usuario_desarrollo;
      this.detalleIncidencia.id_emp_reasignado = desarrollador;
    }

    // Una reasignación nunca es un comentario: esComentario es la marca de
    // notificación del tablero y llega null (o 1), y con el mismo estatus el
    // servidor la desempacaba (NPE) o la guardaba como comentario.
    const incidenciaActualizada = {
      ...this.detallemodal,
      descincidencia: this.motivo,
      detalleBean: this.detalleIncidencia,
      id_version_incidencia: this.detallemodal.version,
      id_usuario_desarrollo: desarrollador,
      estatus: estatusSiguiente,
      esComentario: Constantes.CERO,
    };

    this.incidenciasService
      .guardaComentario(incidenciaActualizada)
      .subscribe((incidencia) => {
        // Un rechazo (VAL-*) o una respuesta vacía no se pintan como éxito.
        const rechazo = rechazoDelGuardado(incidencia);
        if (rechazo) {
          this.avisaRechazo(rechazo);
          return;
        }
        swal
          .fire({
            text: MensajesFijosEnum.INCIDENCIA_EXITOSA,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
            icon: "success",
          })
          .then(() => {
            this.actualiza(incidencia, {
              descincidencia: this.motivo,
              detalleBean: this.detalleIncidencia,
              id_version_incidencia: this.detallemodal.version,
              id_usuario_desarrollo: desarrollador,
            });
          });
      });
  }

  actualiza(
    incidencia: Incidencias,
    cambios: Partial<Incidencias> = {}
  ) {
    this.selectedEmpleado = null;
    this.motivo = "";
    this.programaActualizacionEstado(
      incidencia.estatusPrevio,
      incidencia.id,
      cambios,
      () => {
        const idAsignado = cambios.id_usuario_desarrollo;
        if (idAsignado !== null && idAsignado !== undefined) {
          this.nombreCompletoAsignado =
            this.listaEmpleados?.find(
              (empleado) => empleado?.usuario?.id === idAsignado
            )?.persona?.nombreCompleto || "N/A";
        } else if (this.detallemodal.id_usuario_desarrollo === 0) {
          this.nombreCompletoAsignado = "N/A";
        }
        this.getDetalleIncidencia();
      }
    );
  }

  private obtenerColorEstatus(estatus: string): string {
    switch (estatus) {
      case Constantes.ABIERTO: {
        return Constantes.ABIERTOCOLOR;
      }
      case Constantes.OBSERVACIONES: {
        return Constantes.OBSERVACIONESCOLOR;
      }
      case Constantes.PROCESO: {
        return Constantes.PROCESOCOLOR;
      }
      case Constantes.RESUELTO: {
        return Constantes.RESUELTOCOLOR;
      }
      case Constantes.REVISION: {
        return Constantes.REVISIONCOLOR;
      }
      case Constantes.VOBO: {
        return Constantes.VOBOCOLOR;
      }
      case Constantes.CANCELADO: {
        return Constantes.CANCELADOCOLOR;
      }
      default: {
        return "#f25c05";
      }
    }
  }

  private programaActualizacionEstado(
    estatus: string,
    id?: number,
    cambios: Partial<Incidencias> = {},
    despues?: () => void
  ): void {
    queueMicrotask(() => {
      const color = this.obtenerColorEstatus(estatus);
      this.detallemodal = {
        ...this.detallemodal,
        ...cambios,
        estatus,
        colorEstatus: color,
        ...(id === null || id === undefined ? {} : { id }),
      };
      this.statusColor = color;
      this.muestraBotones(estatus);
      despues?.();
      this.cdr.markForCheck();
    });
  }

  agregaComentario(titulo: string) {
    if (titulo !== "Resuelto") {
      this.abreDialogoMovimiento(titulo, null);
      return;
    }

    // T3b: si la incidencia es trazable no se elige versión; la resolución se
    // entrega en la siguiente versión QA de la etapa (plan §5.6). Si no, el
    // selector de siempre, que excluye la versión reportada.
    if (this.abriendoResolucion) {
      return;
    }
    this.abriendoResolucion = true;
    void this.esperaEstadoResolucion()
      .then((estado) => {
        if (resuelveSinSelector(estado)) {
          this.abreDialogoMovimiento(titulo, this.tarjetaSinSelector(estado));
        } else if (this.obtenerVersionesValidasParaResolver().length === 0) {
          this.mostrarAlertaVersionNoValida();
        } else {
          this.abreDialogoMovimiento(titulo, null);
        }
      })
      .finally(() => {
        this.abriendoResolucion = false;
        this.cdr.markForCheck();
      });
  }


  /** Lo que dice la tarjeta «Versión donde se resolvió» en lugar del selector. */
  private tarjetaSinSelector(estado: ResolucionEstado | null): ResolucionSinSelector {
    return {
      seEntregaraEn: proximaVersionQA(estado?.etapa?.nombre),
      versionVigente: textoVersionVigente(estado),
    };
  }

  private abreDialogoMovimiento(titulo: string, sinSelector: ResolucionSinSelector | null) {
    const resolver = titulo === "Resuelto";
    const dialogRef = this.dialog.open(ComentariosDesarrolloComponent, {
      width: "auto",
      maxWidth: "96vw",
      maxHeight: "92vh",
      panelClass: "custom-modalbox",
      data: {
        dataKey: this.detallemodal,
        data: this.detalleProyecto,
        version: this.version,
        versionReportada: this.obtenerIdVersionReportada(),
        titulo,
        idProyecto: this.proyecto?.id,
        idEtapa: this.detallemodal.id_etapa,
        resolucionPrevia: resolver ? this.obtenerUltimaResolucionEstructurada() : null,
        listaVersiones: resolver ? this.obtenerVersionesValidasParaResolver() : this.listaVss,
        sinSelector,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        if (resolver) {
          // Se cerró sin guardar (cancelado o rechazado): el estado de la
          // resolución pudo cambiar (p. ej. se cerró el proyecto y ya no
          // espera versión). El siguiente «Marcar resuelto» lo vuelve a leer
          // en vez de usar el que tenía.
          this.consultaEstadoResolucion();
        }
        return;
      }

      this.programaActualizacionEstado(
        result.estatusPrevio,
        result.id,
        {},
        () => this.getDetalleIncidencia()
      );
    });
  }

  private obtenerVersionesValidasParaResolver(): any[] {
    const idVersionReportada = this.obtenerIdVersionReportada();
    if (!idVersionReportada || !Array.isArray(this.listaVss)) {
      return [];
    }

    return this.listaVss.filter(
      (version) => String(version?.id) !== idVersionReportada
    );
  }

  private obtenerUltimaResolucionEstructurada(): ResolucionEstructurada | null {
    for (const detalle of this.listadetalles) {
      if (!detalle?.id_version_resuelto) {
        continue;
      }
      const resolucion = this.getResolucionEstructurada(detalle);
      if (resolucion) {
        return resolucion;
      }
    }
    return null;
  }

  /**
   * La versión reportada en el alta (incidencia.version): es contra la que el
   * backend valida que la de resolución sea distinta. Antes se tomaba la del
   * último movimiento, que tras unas observaciones de QA ya era la de una
   * resolución anterior: se ofrecía la reportada y el backend la rechazaba.
   */
  private obtenerIdVersionReportada(): string | null {
    const idVersion = this.detallemodal?.version;

    return idVersion === null || idVersion === undefined || idVersion === ""
      ? null
      : String(idVersion);
  }

  private mostrarAlertaVersionNoValida(): void {
    swal.fire({
      text:
        "No se cuenta con una versión válida para marcar como resuelto. Registra una nueva versión del proyecto e inténtalo nuevamente.",
      icon: "info",
    });
  }

  protected avisaFalloDeCarga(): void {
    // Desarrollo no deja rastro en consola: el comentario ya quedó guardado y se avisa igual.
  }

  protected actualizaTrasComentario(incidencia: Incidencias): void {
    this.programaActualizacionEstado(
      incidencia.estatusPrevio,
      incidencia.id,
      {},
      () => {
        this.formComentario.reset();
        this.evidenciaComentario = [];
        this.getDetalleIncidencia();
      }
    );
  }

  fileUrl: any;

  protected refreshView(): void {
    this.cdr.markForCheck();
  }

  protected resolveVersionId(): any {
    return (
      (this.version as any)?.id ??
      this.version ??
      this.detalleIncidencia?.id_version_incidencia ??
      this.detallemodal?.version ??
      null
    );
  }
}
